import React, { useState } from "react";
import * as CompareItemStyles from "../../styles/CompareItem";

export type EmptySlotType = {
    carImage: string;
};

const EmptySlot = (props: EmptySlotType): JSX.Element | null => {
    const { carImage } = props;
    const [hideImage, setHideImage] = useState(false);

    if (hideImage || !carImage) return null;
    return (
        <CompareItemStyles.Placeholder>
            <svg xmlns="http://www.w3.org/2000/svg">
                <filter id="grayscale">
                    <feColorMatrix type="saturate" values="0" in="SourceGraphic" />
                    <feComponentTransfer result="contrast">
                        <feFuncR type="linear" slope="0.1" intercept="-0.5" />
                        <feFuncG type="linear" slope="0.1" intercept="-0.5" />
                        <feFuncB type="linear" slope="0.1" intercept="-0.5" />
                    </feComponentTransfer>
                </filter>
                <image
                    filter="url(#grayscale)"
                    xlinkHref={carImage}
                    width="100%"
                    height="100%"
                    // eslint-disable-next-line react/no-unknown-property
                    onError={() => setHideImage(true)}
                />
            </svg>
        </CompareItemStyles.Placeholder>
    );
};

export default EmptySlot;
